import { render, staticRenderFns } from "./dislike.vue?vue&type=template&id=898f7676&scoped=true&"
import script from "./dislike.vue?vue&type=script&lang=js&"
export * from "./dislike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898f7676",
  null
  
)

export default component.exports